import React from 'react';
import { View, StyleSheet, Image, Text } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import { formatCurrency } from 'src/utils';
import { warrantyTextStyles } from 'src/views/transactions/TransactionPDF/styles';

interface Props {
  amount: number;
  containerStyle?: Style;
  currencyImgStyle?: Style;
  textStyle?: Style;
  isSIPricing?: boolean;
}

const styles = StyleSheet.create({
  text: {
    fontSize: 8,
    maxLines: 1
  },
  image: {
    height: 7,
    width: 7,
    marginTop: 2,
    marginRight: 2
  },
  container: {
    flexDirection: 'row'
  }
});

// NOTE: Save yourself some headache and do not spend
// so much time on wrong unicode on peso sign.
export const RenderQuotationScreenShotCurrency = ({
  isSIPricing = false,
  amount,
  containerStyle = {},
  textStyle = {},
  currencyImgStyle = {}
}: Props) => {
  return (
    <View style={[styles.container, containerStyle]}>
      {isSIPricing ? (
        <Text style={warrantyTextStyles.openSansRegular}>PHP </Text>
      ) : (
        <Image
          style={[styles.image, { paddingLeft: 2, ...currencyImgStyle }]}
          src="/static/images/icons/ico-php.png"
        />
      )}
      <Text style={[warrantyTextStyles.openSansRegular, textStyle]}>
        {`${formatCurrency(amount, '', 2, { removeCurrency: true })}`}
      </Text>
    </View>
  );
};
